import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAccountToDisplaySelector } from "../redux/actions/user";
import { setIsMobile, useLoadingSelector } from "../redux/actions/app";
import useOrientation from "../utils/hooks/useOrientation";
import React, { useEffect, useState } from "react";
import { fetchCustomPOSA, refetchConfig } from "./init";
import {
  configAnimation,
  configAnimationWithTracking,
  MAIN,
  ONBOARDING,
  ONBOARDING_WITH_TRACKING,
  OTHERS,
  POSA_PRICES,
  PUBLIC_PRICES,
  SIGNUP,
  EMAIL_VERIFICATION,
  subscriptionByQuote,
  subscriptionByQuoteWithTrackingID,
  VALIDATE
} from "../utils/routes/routes";
import scrollToTop from "../utils/helpers/scrollToTop";
import CONFIG from "../model/TSConfig";
import { hotjar } from "react-hotjar";
import KC_Heading1 from "../designsystem/typography/KC-Heading/KC_Heading1";
import { tt } from "../utils/i18n/i18n";
import DebugMenu from "./17_JetpackOnboarding/components/DebugMenu/DebugMenu";
import { CustomAlert } from "../components/common/CustomAlert/CustomAlert";
import SignUp from "./18_LoginV2/component/SignUp";
import EmailVerification from "./18_LoginV2/component/EmailVerification";
import CodeValidation from "./18_LoginV2/component/CodeValidation";
import JetpackOnboarding from "./17_JetpackOnboarding/JetpackOnboarding";
import PublicPOSAPage from "./16_PublicPOSAPage/PublicPOSAPage";
import PublicPrices from "./22_PublicPrices/PublicPrices";
import FullScreenConfigurator from "./19_JetpackConfig/FullScreenConfigurator";
import SubscriptionByQuote from "./20_SubscriptionByQuote/SubscriptionByQuote";
import { LayoutWithNavbar } from "./Layout/Main/LayoutWithNavbar";
import NotFound from "./Layout/NotFound/NotFound";
import { FullScreenLoader } from "../components/Loaders/FullScreenLoader/FullScreenLoader";

export function AppContent() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const history = useHistory();
  const isLoading = useLoadingSelector();
  const orientation = useOrientation();

  const [isTabletPortrait, setIsTabletPortrait] = useState(false);

  const recomputeIsTabletPortrait = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    // https://getbootstrap.com/docs/4.6/layout/overview/
    setIsTabletPortrait(w < h && w >= 768 && w < 992);
  };

  function onAccountToDisplayChanged() {
    if (!accountToDisplay) {
      return;
    }

    if (accountToDisplay?.businessUser) {
      void fetchCustomPOSA(accountToDisplay, dispatch);
      void refetchConfig(accountToDisplay, dispatch);
    } else {
      history.push(SIGNUP);
    }
  }

  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  /**
   * Init Hotjar
   */
  useEffect(() => {
    if (!CONFIG.saasBackendUrl?.includes("localhost")) {
      hotjar.initialize(6534770, 6);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 768));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    recomputeIsTabletPortrait();
  }, [orientation]);

  useEffect(() => {
    onAccountToDisplayChanged();
  }, [accountToDisplay]);

  if (isTabletPortrait) {
    return (
      <div className="d-flex flex-column flex-grow-1 align-items-center justify-content-center gap-xl">
        <img
          src={`/${CONFIG.baseName}/img/logo/kadow_1_line.png`}
          style={{
            width: 300
          }}
        />
        <KC_Heading1
          primary={true}
          text={tt("turn_your_tablet")}
          style={{ fontWeight: "normal" }}
        />
      </div>
    );
  }

  return (
    <>
      {/* <NoSmartphone /> */}
      {/*<ZendeskChatbot />*/}
      <DebugMenu />
      <CustomAlert />
      <Switch>
        <Route path={SIGNUP}>
          <SignUp />
        </Route>
        <Route path={EMAIL_VERIFICATION}>
          <EmailVerification />
        </Route>
        <Route path={VALIDATE}>
          <CodeValidation />
        </Route>
        <Route path={ONBOARDING_WITH_TRACKING}>
          <JetpackOnboarding />
        </Route>
        <Route path={ONBOARDING}>
          <JetpackOnboarding />
        </Route>
        <Route path={POSA_PRICES}>
          <PublicPOSAPage />
        </Route>
        <Route path={PUBLIC_PRICES}>
          <PublicPrices />
        </Route>
        <Route path={configAnimationWithTracking}>
          <FullScreenConfigurator />
        </Route>
        <Route path={configAnimation}>
          <FullScreenConfigurator />
        </Route>

        <Route path={subscriptionByQuote}>
          <SubscriptionByQuote />
        </Route>
        <Route path={subscriptionByQuoteWithTrackingID}>
          <SubscriptionByQuote />
        </Route>

        <Route path="/:trackingID">
          <LayoutWithNavbar />
        </Route>
        <Route path={MAIN} exact>
          <LayoutWithNavbar />
        </Route>

        <Route path={OTHERS} component={NotFound} />
      </Switch>
      <FullScreenLoader loading={isLoading} />
      {/*<WhatsAppButton />*/}
    </>
  );
}
